import { ReactNode } from 'react';
import { AccordionContextValue } from '~/components/Accordion/v2/Accordion.hooks';
import { DropdownButton } from '~/components/Dropdown/Button/DropdownButton';
import { DropdownMenu } from '~/components/Dropdown/Menu/DropdownMenu';
import { DropdownRoot, DropdownRootProps } from '~/components/Dropdown/Root/DropdownRoot';

export type DropdownProps = {
  title?: ReactNode | ((value: AccordionContextValue) => ReactNode);
} & DropdownRootProps;

export const Dropdown = ({ title, children, ...props }: DropdownProps) => (
  <DropdownRoot {...props}>
    <DropdownButton>{title}</DropdownButton>
    <DropdownMenu>{children}</DropdownMenu>
  </DropdownRoot>
);

Dropdown.Root = DropdownRoot;
Dropdown.Button = DropdownButton;
Dropdown.Menu = DropdownMenu;
